// @flow
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import TextTruncate from "react-text-truncate";
import I18n from "../../../i18n/I18n";
import { Badge, Status } from "../../common/";
import Helper from "../../../helper/Helper";
import styles from "./OrderBox.scss";

const OrderBox = (props: Object) => {
  const order = props.order;
  return (
    <div className={styles.ctr}>
      <div className={styles.flexer}>
        <div className={styles.statusCtr}>
          <Status status={order.status} />

          <div className={styles.date} style={{ direction: "ltr" }}>
            {order
              ? moment(order.created_at || order.createdAt).format(
                  `YYYY-MM-DD [${props.lang === "ar" ? "" : "at"}] h:mm:ss a`
                )
              : ""}
          </div>
        </div>
        <div>
          {order.business_model === "Fulfilled by noon" ||
          order.fulfillmentMethod === "Fulfilled by noon" ||
          order.isFbn ? (
            <Badge />
          ) : order.business_model === "Seller B2B" ||
          order.fulfillmentMethod === "Seller B2B" ? (
            <Badge sellerB2B />
          ) : (
            order.business_model || order.fulfillmentMethod
          )}
        </div>
      </div>
      <div className={styles.attrCtr}>
        <div className={styles.eachAttr}>
          <h6 className={styles.attrTitle}>
            {I18n.getText("order.order-table-p-number", {}, "Po Number")}
          </h6>
          <div className={styles.attrVal}>
            {order ? order.po_nr || order.poNr : ""}
          </div>
        </div>
        <div className={styles.eachAttr}>
          <h6 className={styles.attrTitle}>
            {I18n.getText("order.order-table-qty", {}, "Quantity")}
          </h6>
          <div className={styles.attrVal}>{order.quantity}</div>
        </div>
        <div className={styles.eachAttr}>
          <h6 className={styles.attrTitle}>
            {I18n.getText("order.order-table-total", {}, "Total")}
          </h6>
          <div className={styles.attrVal}>
            {I18n.formatCurrency(
              Helper.formatPrice(order.total, props.currencyCode)
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

OrderBox.propTypes = {};

OrderBox.getDefaultProps = {};

export default OrderBox;



// WEBPACK FOOTER //
// ./src/components/orders/orderBox/OrderBox.js